export const MockAccountAdminProduct = {
    productId: 1,
    productName: "Account Admin",
};
